import { render, staticRenderFns } from "./UsernamePOSDetail.vue?vue&type=template&id=966354d6&scoped=true"
import script from "./UsernamePOSDetail.vue?vue&type=script&lang=js"
export * from "./UsernamePOSDetail.vue?vue&type=script&lang=js"
import style0 from "./UsernamePOSDetail.vue?vue&type=style&index=0&id=966354d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966354d6",
  null
  
)

export default component.exports